import BaseModelAPI from '../BaseModelAPI';

export default class ReportStockCard extends BaseModelAPI {
	static entity = 'newreport2001';
	static entityName = 'reportstockcard';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.filterPart = '';
		this.filterRack = '';
		this.filterCustomer = '';
		this.filterArea = '';
		this.filterControlCard = '';
		this.filterUom = '';
		this.filterQcStatus = '';
		this.filterTransactionDate = '';
		this.tempId = 0;
		this.areaName = '';
		this.rackName = '';
		this.customerName = '';
		this.partClassificationCode = '';
		this.controlCardNumber = '';
		this.partNumber = '';
		this.partName = '';
		this.qtyCase = 0;
		this.uomName = '';
		this.createdDate = '';
		this.qcStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

}